module.exports = __webpack_public_path__ + "static/media/roma-3.ccd20d80.jpg";